import Apify from '@module/apify';

export default Apify({
  unsubscribeExpiration: {
    path: '/api/v4/transfers/opted_out_expiration_reminder',
    method: 'POST',
  },
});
